import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseTypographyComponent } from '../base-typography.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-body',
  template: '<span [ngClass]="ngClass"><ng-content></ng-content></span>',
  styleUrls: ['./body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class BodyComponent extends BaseTypographyComponent {}
